export default "__VITE_ASSET__4b1f113a__"